import { initialiseInstanceComponents } from "../../shared/instanceComponentInitialiser";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { SinglePagingSelectableCarousel } from "../selectableCarousel/singlePagingSelectableCarousel";

export function initialiseSinglePagingSelectableCarousel() {
    initialiseInstanceComponents<SinglePagingSelectableCarousel>(SinglePagingSelectableCarousel,
        HelperUtils.addDataAttributeTags(AttributeEnums.SinglePagingSelectableCarousel.SinglePagingSelectableCarousel),
        singlePagingSelectableCarouselFactory);
}

function singlePagingSelectableCarouselFactory(currentElement: Element): void {
    let componentOrientation = currentElement.getAttribute(AttributeEnums.SelectableCarousel.ComponentOrientation);
    let componentOrientationEnum = (UtilityEnums.ComponentOrientation.Horizontal === componentOrientation) ? UtilityEnums.ComponentOrientation.Horizontal : UtilityEnums.ComponentOrientation.Vertical;
    let newSinglePagingSelectableCarousel = new SinglePagingSelectableCarousel(currentElement, componentOrientationEnum);
    (<any>window)[currentElement.getAttribute(AttributeEnums.SinglePagingSelectableCarousel.SinglePagingSelectableCarousel) + 'SinglePagingSelectableCarousel'] = newSinglePagingSelectableCarousel;
}